import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

// This controller is used to manage leads list search function
export default class extends Controller {
  static get targets() {
    return ["listsSelect", "teamMembersSelect"]
  }

  static get values() {
    return {
      currentParams: Object,
      currentList: { type: Number, default: 0 },
      currentListUser: { type: Number, default: 0 },
      favoriteLists: Array,
    }
  }

  connect() {
    this.initializeListsSelect()
    this.initializeTeamMembersSelect()
  }

  disconnect() {
    // Destroy the Selectize element to avoid duplication of the field
    if (this.listsSelectize !== undefined) {
      this.listsSelectize[0].selectize.destroy()
    }
  }

  initializeListsSelect() {
    if (!this.hasListsSelectTarget) {
      return
    }

    this.listsSelectize = $(this.listsSelectTarget).selectize({
      openOnFocus: false,
      onChange: function (value) {
        Turbo.visit(`/leads?leads_list_id=${value}`)
      },
      onInitialize: function () {
        $(this.$wrapper).show()
      },
    })
  }

  initializeTeamMembersSelect() {
    const self = this

    if (this.hasTeamMembersSelectTarget === false) {
      return
    }

    $(this.teamMembersSelectTarget).selectize({
      openOnFocus: false,
      plugins: ["clear_button"],
      onChange: function (value) {
        let params = new URLSearchParams()

        if (
          self.currentListValue === 0 ||
          self.currentListUserValue == value ||
          value == "" ||
          self.favoriteListsValue.includes(self.currentListValue)
        ) {
          params = new URLSearchParams(location.search)
        }

        params.set("leads_lists_user_id", value)

        let url = `/leads?${params.toString()}`

        Turbo.visit(url)
      },
      onInitialize: function () {
        $(this.$wrapper).show()
      },
    })
  }
}
